import { useTranslation } from 'react-i18next';

import { Content, ContentWrapper } from '../../components/Content';
import { AuthBtns } from '../AuthBtns';
import { dashboardImg } from './data';
import * as Styled from './SimpleDashboard.styles';

const SimpleDashboard = () => {
  const { t } = useTranslation();

  return (
    <Styled.SimpleDashboard id="simple-dashboard">
      <ContentWrapper>
        <Content
          labels={[t('homeSimpleDashboard.label')]}
          title={t('homeSimpleDashboard.title')}
        />

        <Styled.Bottom>
          <Styled.Img
            src={dashboardImg.src}
            alt={t('homeSimpleDashboard.imgAlt')}
          />
          <AuthBtns />
        </Styled.Bottom>
      </ContentWrapper>
    </Styled.SimpleDashboard>
  );
};

export default SimpleDashboard;
